import { createStyles, Theme } from '@nelnet/unifi-components-react';

const pagestyles = ({ breakpoints, spacing, typography }: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      maxWidth: '1325px',
      flexGrow: 1,
      marginTop: `${spacing(8)}px`,
      paddingLeft: `${spacing(3)}px`,
      [breakpoints.up('md')]: {
        paddingLeft: `${spacing(6)}px`,
      },
      '&:focus': {
        outline: 'none',
      },
    },
    rootHome: {
      paddingLeft: 0,
      maxWidth: '100%',
      [breakpoints.up('md')]: {
        marginLeft: '240px',
      },
    },
    rootWide: {
      maxWidth: '100% !important',
    },
    page: {
      '& > div > h1': {
        marginTop: `${spacing(6)}px`,
      },
      '& > div > h1:focus': {
        outline: 'none',
      },
      '& #intro, & > div:not([class*="collapse"]):not([class*="Grid"]):not([class*="jss"]):not([class*="boldDivider"]) > *:not(.react-live):not([class*="Grid"]):not([style]):not(#status)':
        {
          maxWidth: '800px',
        },
      '& p > div([class*="boldDivider"]), div([class*="boldDivider"]) > p': {
        maxWidth: '100%',
      },
      '& > div > ul ul, & > div > article > ul ul': {
        marginTop: `${spacing(1)}px`,
        marginBottom: `${spacing(1.5)}px`,
      },
      '& > div > ul li p, & > div > article > ul li p': {
        marginBottom: 0,
      },
      '& > div > ul + p, & > div > ol + p, & > div > article > ul + p, & > div > article > ol + p, & > div > h4 + div':
        {
          marginTop: `${spacing(3)}px`,
        },
      '& > div > h2, & > div > h3': {
        marginTop: `${spacing(5)}px`,
        marginBottom: `${spacing(3)}px`,
      },
      '& > div > article > h3': {
        fontSize: typography.overline.fontSize,
        letterSpacing: typography.overline.letterSpacing,
        textTransform: typography.overline.textTransform,
        lineHeight: typography.overline.lineHeight,
        marginTop: `${spacing(3)}px`,
        marginBottom: '0 !important',
      },
      '& > div > p + hr, & > div > ul + hr': {
        marginTop: `${spacing(4)}px`,
      },
      '& > div:not([class*="Grid"])': {
        '& > *:not(p):not(h4) + *:not(p), & > .react-live + *, & > *:not(h4) + .react-live': {
          marginTop: `${spacing(6)}px`,
        },
      },
      '& > div > article > p': {
        marginBottom: spacing(3),
        '& span': {
          lineHeight: 0,
        },
      },
      '& > div > article > ul li + li': {
        marginTop: spacing(0.5),
      },
      '& > div > article > p + h3': {
        marginTop: 0,
      },
      '& > div > article > h3 + ul, & > div > article > h3 + p': {
        marginTop: spacing(1),
      },
      '& > div > article > ul + h3, & > div > .react-live + ul, & > div > div + h5': {
        marginTop: spacing(3),
      },
      '& > div > article': {
        '& *:last-child': {
          marginBottom: 0,
        },
      },
      '& > div > h5, & > div > ul + button': {
        marginTop: `${spacing(2)}px`,
      },
      '& > div > a + p': {
        marginTop: spacing(2),
      },
      '& > div pre': {
        fontSize: '13px',
      },
      '& > div > code, & > div > * code': {
        display: 'inline-block',
        padding: '0 4px',
        background: '#fff',
        fontSize: '13px !important',
        fontWeight: 'normal',
        whiteSpace: 'pre-wrap',
        backgroundColor: '#fff',
        color: '#2C658A',
        border: '1px solid #e9e9e9',
        fontFamily: `Consolas, Menlo, Monaco, 'Andale Mono WT', 'Andale Mono', 'Lucida Console',
        'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono',
        'Nimbus Mono L', 'Courier New', Courier, monospace`,
        lineHeight: '1.7',
        '&::selection': {
          backgroundColor: '#ACCEF7',
        },
      },
      '& > div': {
        '& > h2, & > h3, & > h4, & > h5, & .table-code': {
          '& > code': {
            color: '#2C658A',
            fontFamily: `Consolas, Menlo, Monaco, 'Andale Mono WT', 'Andale Mono', 'Lucida Console',
        'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono',
        'Nimbus Mono L', 'Courier New', Courier, monospace`,
            fontSize: '0.9em !important',
            padding: 0,
            backgroundColor: 'unset',
            border: 0,
          },
        },
      },
      '& > div > p > a > code': {
        fontFamily: `Consolas, Menlo, Monaco, 'Andale Mono WT', 'Andale Mono', 'Lucida Console',
        'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono',
        'Nimbus Mono L', 'Courier New', Courier, monospace`,
        fontSize: '.95em',
      },
      '& > div > p + code, & > div > ul + code, & > div > ol + code': {
        margin: `0 0 ${spacing(2)}px 0`,
        padding: `${spacing(0.5)}px ${spacing(1)}px`,
      },
      '& > div > ul + code, & > div > ol + code, & > div > h4 + code': {
        marginTop: spacing(2),
      },
      '& > div table a': {
        color: '#3473AC',
      },
      '& > div .gatsby-resp-image-wrapper': {
        margin: '2em 0 !important',
      },
      '& > div > p code:only-child': {
        margin: 0,
      },
      '& .block-img img': {
        maxWidth: '100%',
        boxShadow: '0 5px 7px -3px rgba(0,0,0,0.38)',
      },
    },
    formDemo: {
      '& .react-live > div > div:first-child': {
        backgroundColor: '#fff',
        height: '100%',
      },
    },
  });

export default pagestyles;
